
function chapterGroupComponent(dataTarget) {
    const chapterIndexList = document.querySelectorAll(`[data-chapter-group="${dataTarget}"]`)
    const chapterGroupHimself = document.querySelector(`[data-chapter-related-group="${dataTarget}"]`)
    //console.log('chapterIndexList', chapterIndexList)
    
    for (const chapter of chapterIndexList) {
      if (chapter.classList.contains('chapter-sidebar--hidden')) {
        chapter.classList.remove('chapter-sidebar--hidden');
      } else {
        chapter.classList.add('chapter-sidebar--hidden');
      }
    }
  
    if (chapterGroupHimself.classList.contains('sidebar-group-opened')) {
      chapterGroupHimself.classList.remove('sidebar-group-opened');
    } else {
      chapterGroupHimself.classList.add('sidebar-group-opened');
    }
}

function showChapter(target) {

const allChapters = document.querySelectorAll('[chapter-target]')
for (const chapter of allChapters) {
    chapter.parentNode.classList.remove('single-chapter--display')
}

    console.log('allChapters')
const chapterTarget = document.querySelector(`[chapter-target="${target}"]`);
const chapterParent = chapterTarget.parentNode;
chapterParent.classList.add('single-chapter--display')
toggleSidebar()
}
function toggleSidebar() {
    const sidebar = document.querySelector('chapter-sidebar');
    const sidebarState = sidebar.dataset.hamburguerState;
    console.log("entro", sidebarState)
    if(sidebarState === 'open'){
    //sidebar.classList.add('chapter-sidebar--hidden');
    sidebar.dataset.hamburguerState = 'close'
    }else{
    sidebar.dataset.hamburguerState = 'open'
    //sidebar.classList.add('chapter-sidebar--show');
    }

    // Alternar la visibilidad del sidebar
    /*if (sidebar.style.display === 'none' || sidebar.style.display === '') {
        sidebar.style.display = 'block';
    } else {
        sidebar.style.display = 'none';
    }*/
}

document.addEventListener('shopify:section:select', function (event) {
    const chapterAttr = event.target.firstChild.attributes[0].value;
    showChapter(chapterAttr);
 });